import { useState } from "react";
import { cn } from "lib/utils";

/** White rounded panel used across the admin screens. */
export function AdminCard({ children, className }) {
  return (
    <div
      className={cn(
        "bg-white border border-[#e6e9ec] rounded-2xl shadow-[0_1px_3px_rgba(0,0,0,0.04)]",
        className
      )}
    >
      {children}
    </div>
  );
}

/** Card header with a title and optional right-aligned action. */
export function AdminCardHead({ title, action }) {
  return (
    <div className="px-[22px] py-4 border-b border-[#eef1f3] flex justify-between items-center">
      <div className="font-bold text-[15px] text-green-dark">{title}</div>
      {action}
    </div>
  );
}

/** iOS-style on/off switch. */
export function Toggle({ initial = false }) {
  const [on, setOn] = useState(initial);
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      onClick={() => setOn((v) => !v)}
      className={cn(
        "relative w-11 h-[25px] rounded-full shrink-0 transition-colors duration-200",
        on ? "bg-green" : "bg-[#cdd4d9]"
      )}
    >
      <span
        className="absolute top-[3px] w-[19px] h-[19px] rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.3)] transition-[left] duration-200"
        style={{ left: on ? 22 : 3 }}
      />
    </button>
  );
}

/**
 * Shown when an editor failed to fetch its saved content.
 * Without this the form renders empty and a Save would overwrite the live
 * rows with nothing — so pages that show this must also block saving.
 */
export function LoadFailedBanner({ onRetry }) {
  return (
    <div className="text-[13px] text-[#8a6d00] bg-gold/[0.12] border border-gold/30 rounded-lg px-4 py-3 mb-4">
      <strong>This page didn't load your saved content.</strong> The form below is empty
      because of that — it does <em>not</em> mean your content was deleted. Saving is
      disabled so it can't overwrite it.{" "}
      <button
        onClick={onRetry}
        className="underline bg-transparent border-none p-0 cursor-pointer text-[#8a6d00] font-semibold"
      >
        Try again
      </button>
    </div>
  );
}
